export enum ECompareType {
    PreviousYear = "previous year",
    PreviousPeriod = "previous period",
}
